// extracted by mini-css-extract-plugin
export var actions = "_sl-4";
export var item = "_sl-1";
export var price = "_sl-3";
export var quantity = "_sl-2";
export var table = "_sl-0";